export type SpecialCharacterURLEncoder = {
    [key: string]: string;
};

export const SpecialCharactersURLEncoder: SpecialCharacterURLEncoder = {
    '#': '%23',
    '&': '%26',
};

export enum BrokerFeeType {
    Fixed = 'Fixed',
    Percentage = 'Percentage',
}

export const BROKER_FEE_PERCENTAGE_TYPE_MAX = 50;
export const WINDOW_THRESHOLD_WIDTH = 992;
export const DEBOUNCE_DELAY = 500;
export const isLargeScreen: boolean = window.innerWidth >= 1000;
export const PERCENTAGE = 100;

export enum CustomHttpStatusCode {
    ValidateDriverAssignmentToTrailer = 701,
    DuplicateEntry = 702,
    assignDriverBeforeDispatching = 710,
    PublishToServiceBusQueueError = 707,
    QuickBooksUserNotCreated = 708,
    QuickBooksOnlineAuthError = 499,
}

export const allowedSpecialCharacters = '! @ $ % & _ * .';
export const specialCharacterRegex = /[!@$%&_*.\u002A]/;

export const onlyAllowedCharactersRegex = /^[a-zA-Z0-9!@$%&_*.]*$/;

export const validatePasswordChecklist = (
    password: string,
    isStrictSpecialCharValidationEnabled = false,
): {
    minLength: boolean;
    hasNumber: boolean;
    hasSpecialChar: boolean;
    hasUpperCase: boolean;
    hasLowerCase: boolean;
} => ({
    minLength: password.length >= 12,
    hasNumber: /\d/.test(password),
    hasSpecialChar: isStrictSpecialCharValidationEnabled
        ? specialCharacterRegex.test(password) &&
          onlyAllowedCharactersRegex.test(password)
        : specialCharacterRegex.test(password),
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
});

export const SIGN_UP = 'signUp';
export const attachmentTypeString = 'Must upload a file of type';
export const attachmentSizeString = '50 MB';
export const defaultLoadTime = '00:00';
export const chunkError = [
    'ChunkLoadError',
    'Loading chunk',
    "Unexpected token '<'",
];
